import { JSX } from "react";

const ProvidersByGeocodeDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By Geocode card summarizes the network providers geocoding outcome.
      Geocoding the data is necessary to provide a latitude and longitude coordinate for the purposes of measuring Network Adequacy in QES®.
    </p>
    <p>
      Providers without a GeoInfo value will be grouped as “Unknown.”
    </p>
    <p>
      Geocoding outcome definitions can be found below:
    </p>
    <ul>
      <li><b>Address-Exact</b>: The record was geocoded at the exact address level.</li>
      <li>
        <b>Address-Relaxed</b>: The record was geocoded at the address level, but a component was missing, such as directional prefixes/suffixes or street type.
        Another potential scenario is if the city and state fields match up to the street address, but only the zip is incorrect.
        The system will attempt to match without the zip code.
      </li>
      <li>
        <b>Address-Relaxed-ZipMismatched</b>: While the record contained a full street address, the zip code was invalid or missing.
        Zip code correction replaced this record&apos;s invalid or missing zip code with the correct zip code.
      </li>
      <li><b>Zip-Invalid</b>: The zip code is not valid and was not able to be corrected with geocoding.</li>
      <li>
        <b>Zip-Distributive</b>: These records were not geocoded at the address level and defaulted to an algorithm using population patterns within the zip code to assume a latitude and longitude.
        Zip distributive points will be more heavily plotted in those areas of a zip code that are more densely populated.
        Keep in mind that the points plotted are approximate and are not based upon the actual street address.
        The plotted location can change with each data refresh.
      </li>
      <li>
        <b>Zip-Legacy</b>: Refers to a zip code that is no longer valid but is still used in calculations for reports.
        Quest Analytics® provides this functionality because our users often run into outdated zip codes in member files.
        For the more recent outdated zip codes, we attribute the legacy zip code&apos;s previous longitude and latitude.
        The Zip-Legacy zip code will not plot on a map; however, it will be included in the calculations and reports.
      </li>
      <li>
        <b>Zip-Point</b>: The zip code is a point zip (PO box, building, office, etc.) and the latitude and longitude are assigned based on the specific point in the zip code.
        An example of a Zip-Point is the Empire State Building, as it has its own zip code.
      </li>
    </ul>
  </>;
}

export { ProvidersByGeocodeDescription };